import { z } from 'zod';
import { memberWeeklyHoursSchema } from './catalog.js';
/**
 * Wizard de primeira configuração (docs/roadmap-wizard-ajuda-autocadastro.md §1): estado gravado em Business.onboarding.
 * AVAILABLE até alguém concluir ou encerrar (a Ativação é o assistente); DONE quando a proposta foi aplicada ao menos uma
 * vez; SKIPPED quando o admin preferiu o checklist (ou o negócio é anterior à funcionalidade). Sem prazo: em DONE e
 * SKIPPED o assistente continua a um toque na Ativação, e cada conversa consome a cota de IA do negócio.
 */
export const WIZARD_STORED_STATUSES = ['AVAILABLE', 'DONE', 'SKIPPED'];
export const SETUP_WIZARD_SCOPES = ['business', 'team', 'ai', 'scheduling', 'services', 'hours'];
/** Parte "business" da proposta do assistente (dados cadastrais que o wizard pode preencher). */
export const assistantBusinessPartSchema = z.object({
    name: z.string().trim().min(2).max(120).optional(),
    segment: z.string().trim().max(80).nullable().optional(),
    address: z.string().trim().max(300).nullable().optional(),
    phone: z.string().trim().max(32).nullable().optional(),
    timezone: z.string().min(3).max(64).optional(),
    modality: z.enum(['LOCAL', 'HOME', 'BOTH']).optional(),
});
/** Parte "team": profissionais existentes (memberId) ou a convidar (sem memberId). Serviços por nome, resolvidos ao aplicar. */
export const assistantTeamItemSchema = z.object({
    memberId: z.string().uuid().optional().describe('id do membro existente; omita para convidar uma pessoa nova'),
    name: z.string().trim().min(2).max(120),
    email: z.string().trim().email().max(200).optional().describe('obrigatório para pessoa nova (recebe o convite)'),
    role: z.enum(['ADMIN', 'STANDARD']).optional(),
    services: z.array(z.string().trim().min(1).max(120)).max(60).optional().describe('nomes dos serviços que atende (do cadastro ou da parte services desta proposta)'),
    workingHours: memberWeeklyHoursSchema.nullable().optional().describe('horário individual; null = segue o do negócio'),
    canBeSubstitute: z.boolean().optional(),
});
//# sourceMappingURL=onboarding.js.map